module.exports = __webpack_public_path__ + "img/save.786b51ee.svg";